import { Injectable } from '@angular/core';
import { MENUITEMS } from '../data/menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  
  getMenu() {
    return MENUITEMS;
  }
}
